import FontAwesome from '@vromo/ui/components/FontAwesome';
import theme from '@vromo/ui/components/theme';
import Tooltip from '@vromo/ui/components/Tooltip';
import React, { memo } from 'react';
import { CSSProperties } from 'react';
import { HeaderRight } from '../Components';
import styles from '../driverReport.style';

const TableHeaders = memo(
    ({
        distanceUnit,
        getLocale
    }: {
        distanceUnit: string;
        getLocale: (key: string, params?: { unit?: string }) => string;
    }) => {
        return (
            <thead>
                <tr>
                    <th>{getLocale('name')}</th>
                    <th>{getLocale('group')}</th>
                    <th style={styles.infoTitle as CSSProperties}>
                        {getLocale('availableHours')}
                        <Tooltip position="bottom" label={getLocale('availableHoursTooltip')}>
                            <div style={styles.infoIconContainer}>
                                <FontAwesome
                                    icon="info-circle"
                                    weight="duotone"
                                    colour={theme.lightGrey}
                                />
                            </div>
                        </Tooltip>
                    </th>
                    <HeaderRight>{getLocale('timeOnJob')}</HeaderRight>
                    <HeaderRight>{getLocale('jobsCompleted')}</HeaderRight>
                    <HeaderRight>{getLocale('jobsCancelled')}</HeaderRight>
                    <HeaderRight>{getLocale('jobsReOffered')}</HeaderRight>
                    <HeaderRight>{getLocale('totalDistance', { unit: distanceUnit })}</HeaderRight>
                    <HeaderRight>{getLocale('onJobDistance', { unit: distanceUnit })}</HeaderRight>
                    <HeaderRight>{getLocale('offJobDistance', { unit: distanceUnit })}</HeaderRight>
                    <HeaderRight>{getLocale('averageRating')}</HeaderRight>
                    <HeaderRight>{getLocale('payEstimate')}</HeaderRight>
                    <HeaderRight>{getLocale('costPerJob')}</HeaderRight>
                </tr>
            </thead>
        );
    }
);

export default TableHeaders;
